import {cn} from '@bem-react/classname';

export const cnIconRefuge = cn('icon-refuge');
